<div class="flex flex-col">

    <!-- Spinner -->
    <div *ngIf="showSpinner" class="absolute top-2/4 left-2/4">
        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </div>

    <!-- Viewer content -->
    <div class="flex-grow">
        <div class="pdf-container">
            <pdf-viewer class="w-full h-full" #pdfViewer [(page)]="page" [zoom]="zoom" [show-borders]="true" (after-load-complete)="setView()"
                (error)="unableToLoadPdf()" [fit-to-page]="true" [autoresize]="true" [show-all]="showAll"
                [stick-to-page]="stickToPage" [src]="pdfSrc" [render-text]="true" [original-size]="true">
            </pdf-viewer>
        </div>
    </div>
    <!-- Viewer content -->

    <!-- Controls content -->
    <div class="fixed left-0 right-0 bottom-3 bg-gray-700 w-fit m-auto p-2 rounded-lg opacity-90 z-10">
        <div class="flex flex-row justify-between space-x-4 divide-x divide-gray-500">

            <div class="page flex flex-row items-start">
                <button (click)="navigatePage('decrement')"
                    class="text-3xl py-1 px-1 mr-1 font-medium flex items-center text-white hover:bg-gray-500 rounded-lg">
                    <em class="ti ti-chevron-left"></em>
                </button>
                <input [(ngModel)]="page" class="w-15 border bg-white rounded px-3 py-1 text-center" id="page_no" type="text"
                    placeholder="{{'text.page' | translate}}">
                <button (click)="navigatePage('increment')"
                    class="text-3xl py-1 px-1 ml-1 font-medium flex items-center text-white hover:bg-gray-500 rounded-lg">
                    <em class="ti ti-chevron-right"></em>
                </button>
            </div>

            <div class="zoom flex flex-row items-start pl-4">
                <button (click)="changeZoomSize('-')"
                    class="text-3xl py-1 px-1 mr-1 font-medium flex items-center text-white hover:bg-gray-500 rounded-lg">
                    <em class="ti ti-zoom-out"></em>
                </button>
                <!-- <input [(ngModel)]="zoom" id="zoom_no" class="w-15 border px-3 py-1 text-center" type="text"> -->

                <button (click)="changeZoomSize('+')"
                    class="text-3xl py-1 px-1 ml-1 font-medium flex items-center text-white hover:bg-gray-500 rounded-lg">
                    <em class="ti ti-zoom-in"></em>
                </button>
            </div>

            <div class="zoom flex flex-row items-start pl-2">
                <button (click)="downloadPdf()"
                    class="py-1 px-2 ml-1 font-normal flex items-center text-white hover:bg-gray-500 rounded-lg">
                    <em class="ti ti-download text-xl"></em>
                    <span class="ml-1 text-lg">{{'text.download' | translate}}</span>
                </button>
            </div>

        </div>
    </div>
    <!-- Controls content -->
</div>